import axios from 'axios';
import authHeader from '../../../app/axios/header';

export const signIn = async (email: string, password: string) => {
  return axios
    .post(process.env.REACT_APP_API_URL + 'signin', {
      email,
      password,
    })
    .then((response) => {
      if (response.data) {
        localStorage.setItem('token', JSON.stringify(response.data));
      }
      return response.data;
    });
};

export const addUser = async (name: string, email: string, password: string) => {
  return axios
    .post(process.env.REACT_APP_API_URL + 'users', {
      name,
      email,
      password,
    })
    .then((response) => {
      return response.data;
    });
};

export const getUser = async (id: string) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}users/${id}`, { headers: authHeader() })
    .then((data) => {
      return data.data;
    });
};
